import React, { ReactNode } from 'react';

type ConditionalWrapperProps = {
  condition: boolean;
  wrapper?: (children: ReactNode) => ReactNode;
  children: ReactNode;
};

export const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps): JSX.Element => (
  <>{condition && wrapper ? wrapper(children) : children}</>
);
